module.exports = __webpack_public_path__ + "static/media/empty.e91c6713.svg";